"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSocialConnect = void 0;
const react_1 = require("react");
function useSocialConnect() {
    const [success, setSuccess] = (0, react_1.useState)(false);
    const channel = new BroadcastChannel('Tria Auth Channel');
    (0, react_1.useEffect)(() => {
        const authResponse = (event) => {
            try {
                if (event.origin !== window.origin)
                    return;
                window.parent.postMessage(event.data, document.referrer);
                // for unity postMessage to webview
                // window.vuplex.webview
                // console.log('POST MESSAGE DONE on auth invis iframe', event);
                setSuccess(true);
            }
            catch (err) {
                setSuccess(false);
            }
        };
        channel.onmessage = authResponse;
        window.addEventListener('message', authResponse);
        return () => {
            channel.removeEventListener('message', authResponse);
            window.removeEventListener('message', authResponse);
        };
    }, []);
    return { success };
}
exports.useSocialConnect = useSocialConnect;
